import React from "react";

function ActivePaymentLinkIcon() {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#F6FFED" rx="8"></rect>
      <path
        fill="#52C41A"
        d="M24.8 20.18v.9a.9.9 0 00.9-.9h-.9zm0-4.84h.9a.9.9 0 00-.9-.9v.9zm-13.247-4.717a.9.9 0 10.974 1.514l-.974-1.514zM18.2 7.42l.71-.553a.9.9 0 00-1.197-.204l.487.757zm2.37 4.512a.9.9 0 001.42-1.105l-1.42 1.105zm4.23 7.348h-2.86v1.8h2.86v-1.8zm-2.86-3.04h2.86v-1.8h-2.86v1.8zm1.96-.9v4.84h1.8v-4.84h-1.8zm-3.48 2.42c0-.84.68-1.52 1.52-1.52v-1.8a3.32 3.32 0 00-3.32 3.32h1.8zm1.52 1.52c-.84 0-1.52-.68-1.52-1.52h-1.8a3.32 3.32 0 003.32 3.32v-1.8zm-9.413-7.143l6.16-3.96-.974-1.514-6.16 3.96.974 1.514zm4.963-4.165l3.08 3.96 1.42-1.105-3.08-3.96-1.42 1.105zM8.08 12.28h14.96v-1.8H8.08v1.8zm14.96 11.4H8.08v1.8h14.96v-1.8zM8.1 23.7V12.26H6.3V23.7h1.8zm-.02-.02l.008.002a.018.018 0 01.006.004.023.023 0 01.006.014H6.3c0 .983.797 1.78 1.78 1.78v-1.8zm14.94.02c0-.001 0-.005.002-.008a.019.019 0 01.004-.006.018.018 0 01.006-.004.023.023 0 01.008-.002v1.8a1.78 1.78 0 001.78-1.78h-1.8zm.02-11.42a.024.024 0 01-.014-.006.023.023 0 01-.006-.014h1.8a1.78 1.78 0 00-1.78-1.78v1.8zm-14.96-1.8a1.78 1.78 0 00-1.78 1.78h1.8a.024.024 0 01-.006.014.02.02 0 01-.006.004.025.025 0 01-.008.002v-1.8zm14.94 10.36v2.86h1.8v-2.86h-1.8zm0-8.58v2.31h1.8v-2.31h-1.8z"
      ></path>
    </svg>
  );
}

export default ActivePaymentLinkIcon;